<script>
    import UserProfile from '@/components/left-panel/UserProfile.vue';
    import SidebarSearch from '@/components/container/SidebarSearch.vue';

    export default {
        components: {
            UserProfile: UserProfile,
            SidebarSearch: SidebarSearch,
        },
        props: {
            query: {
                type: String,
                default: '',
            },
        },
        emits: ['update:query'],
        methods: {
            onQueryUpdate(value) {
                this.$emit('update:query', value);
            },
        },
    };
</script>

<template>
    <div class="left_panel">
        <UserProfile />
        <hr class="left-separator">
        <SidebarSearch :query="query" @update:query="onQueryUpdate" />
        <div class="left_sub_panel_data">
            <slot></slot>
        </div>
    </div>
</template>